import * as React from 'react';
import { Card } from '@blueprintjs/core';
import PropertyUtil from '../../../util/PropertyUtil';
import Address from '../../../models/Address';
import Landman from '../../../models/Landman';
import Button from '../../controls/forms/redesign/FormButton';

interface ILandmanContactInfoCardProps {
    landman: Landman;
    navigate: (path: string) => void;
}

class LandmanContactInfoCard extends React.Component<ILandmanContactInfoCardProps> {
    onManageContactInfoClick = () => {
        this.props.navigate(`/landmen/${this.props.landman.id}/manage-contact-info`);
    };

    public render() {
        const primaryLandmanPhone = PropertyUtil.SafeGet(() =>
            this.props.landman.phoneNumberList.find((phoneNumber) => {
                return phoneNumber.isPrimary === true;
            })
        );

        const addressPanel = (address: Address | undefined, addressType: string) => {
            let addressDetails: JSX.Element;

            if (!address) {
                addressDetails = <div>No {addressType} provided</div>;
            } else {
                addressDetails = (
                    <div>
                        {address.addressLine1}
                        <br />
                        {`${address.city}, ${address.state.abbreviation} ${address.zipCode}`}
                    </div>
                );
            }

            return (
                <div className="lh-half-width">
                    <div style={{ marginTop: '.5em', fontWeight: 'bold' }}>
                        <u>{addressType}</u>
                    </div>
                    {addressDetails}
                </div>
            );
        };

        return (
            <Card className="lh-half-width" elevation={1}>
                <h6>Contact Information</h6>
                <div>
                    <div className="lh-half-width">Email: {PropertyUtil.SafeGet(() => this.props.landman.username, 'NA')}</div>
                    <div className="lh-half-width">Phone: {PropertyUtil.SafeGet(() => primaryLandmanPhone.number, 'NA')}</div>
                </div>
                <div>
                    {addressPanel(
                        PropertyUtil.SafeGet(() => this.props.landman.primaryAddress),
                        'Primary Address'
                    )}
                    {addressPanel(
                        PropertyUtil.SafeGet(() => this.props.landman.mailingAddress),
                        'Mailing Address'
                    )}
                    <div>
                        <div style={{ marginTop: '.5em', textAlign: 'right' }}>
                            <Button intent="primary" size="medium" text="Manage" onClick={this.onManageContactInfoClick} />
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

export default LandmanContactInfoCard;



// WEBPACK FOOTER //
// ./src/components/personnel/components/LandmanContactInfoCard.tsx